import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";
import type { UserUpdateDto } from "~/modules/user/models/UserUpdateDto.interface";
import userAdministrationService from "~/modules/user/services/userAdministration.service";

export function useUpdateUser({
  businessUnitCode,
  organizationCode,
}: GenericParameters) {
  let service = userAdministrationService.updateSuperAdministrationUser.bind(
    userAdministrationService,
  );
  if (organizationCode) {
    service = userAdministrationService.updateOrganizationUser.bind(
      userAdministrationService,
    );
  } else if (businessUnitCode) {
    service = userAdministrationService.updateBusinessUnitUser.bind(
      userAdministrationService,
    );
  }
  const isLoading = ref<boolean>(false);
  const error = ref<LxcError | null>(null);

  async function updateUser(
    userLogin: string,
    user: UserUpdateDto,
  ): Promise<void> {
    isLoading.value = true;
    error.value = null;
    const response = await service({
      userLogin,
      businessUnitCode,
      organizationCode,
      user,
    });

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    updateUser,
    error,
    isLoading,
  };
}
